import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgChartsModule } from 'ng2-charts';

import { CommonService } from '../../services/common.service';
import { SharedModule } from '../../shared/shared.module';
import { CompanyRouting } from './company.routing';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { UiAvatarImageComponent } from '../../shared/libs/up-header/ui-avatar/ui-avatar-image.component';
import { UpTopHeaderComponent } from '../../shared/libs/up-header/up-top-header/up-top-header.component';
import { MatTabsModule } from '@angular/material/tabs';
import { HasRoleDirective } from '../../services/directives/has-role.directive';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { A11yModule } from '@angular/cdk/a11y';
import { CompanyComponent } from './components/company.component';
import { CompanyOrderListComponent } from './components/company-order-list/company-order-list.component';
import { CompanyPhotographerDetailComponent } from './components/company-photographer-detail/company-photographer-detail.component';
import { CompanyPhotographerListComponent } from './components/company-photographer-list/company-photographer-list.component';
import { CompanyStyleDetailComponent } from './components/company-style-detail/company-style-detail.component';
import { CompanyStyleListComponent } from './components/company-style-list/company-style-list.component'; 
import { CompanyOrderDetailInfoComponent } from './components/company-order-detail/company-order-detail-info/company-order-detail-info.component';
import { AddProductModalComponent } from './components/company-order-detail/company-order-detail-shots/add-product-modal/add-product-modal.component';
import { ApproveOrderNoteComponent } from './components/company-order-detail/company-order-detail-shots/approve-order-note/approve-order-note';
import { CompanyOrderDetailComponent } from './components/company-order-detail/company-order-detail.component';
import { CompanyOrderDetailShotsComponent } from './components/company-order-detail/company-order-detail-shots/company-order-detail-shots.component';
import { CompanyTemplateListComponent } from './components/company-template-list/company-template-list.component';
import { CompanyTemplateDetailComponent } from './components/company-template-detail/company-template-detail.component';
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		NgChartsModule,
		SharedModule,
		CompanyRouting,
		A11yModule,
		UiAvatarImageComponent,
		UpTopHeaderComponent,
		// Material Import:
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		MatButtonModule,
		MatDialogModule,
		MatChipsModule,
		MatIconModule,
		MatTabsModule,
		HasRoleDirective,
		MatSlideToggleModule,
		MatAutocompleteModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatCheckboxModule,
		MatExpansionModule
	],
	declarations: [
		CompanyComponent,
		CompanyOrderListComponent,
		CompanyStyleListComponent,
		CompanyPhotographerListComponent,
		CompanyTemplateListComponent,
		CompanyTemplateDetailComponent,
		CompanyStyleDetailComponent,
		ApproveOrderNoteComponent,
		CompanyPhotographerDetailComponent,
		AddProductModalComponent,

		CompanyOrderDetailComponent,
		CompanyOrderDetailInfoComponent,
		CompanyOrderDetailShotsComponent
	],
	exports: [CompanyComponent],
	providers: [CommonService]
})
export class CompanyModule {}
